import type {
    ModelGradeBodyTypeIdsType,
    CarDataType,
    CompareMotorizationType,
} from "../../../../common-deprecated/features/compare/utils/newCarCompareTypes";
import type { SelectGradeType } from "../compareTypes";
import type { CommonSettingsType } from "../../../../common-deprecated/settings/fetchCommonSettings";
import { isLexus } from "../../../../common-deprecated/settings/utils/commonSettingUtils";

export const getNameFromModelGradeBodyTypeIdsAndAvailabelCars = (
    carIds: ModelGradeBodyTypeIdsType,
    availableCars: SelectGradeType[],
): string => {
    const { model } = carIds;

    const modelObject = availableCars.find(
        (car) => car.modelId === model || car.modelCode.toLowerCase() === model.toLowerCase(),
    );

    return modelObject?.modelName || "";
};

export const getCarName = (car: CarDataType, settings: CommonSettingsType): string => {
    const isLexusSetting = isLexus(settings);

    return isLexusSetting
        ? `${car.modelName || ""} ${car.submodelName || ""} ${car.gradeName || ""}`
        : `${car.submodelName || car.modelName || ""} ${car.gradeName || ""} ${car.bodyTypeName || ""}`;
};

/**
 * Returns the correct title and subtitle which can be used in the AEM Compare
 */
export const getCarNameObject = (
    car: CarDataType,
    settings: CommonSettingsType,
): { title: string; subtitle: string } => {
    const isLexusSetting = isLexus(settings);
    return isLexusSetting
        ? {
              title: car.modelName || "",
              subtitle: `${car.submodelName || ""} ${car.submodelName && car.gradeName ? "-" : ""} ${
                  car.gradeName || ""
              }`,
          }
        : {
              title: car.submodelName || car.modelName || "",
              subtitle: `${car.gradeName || ""} ${car.gradeName && car.bodyTypeName ? "-" : ""} ${
                  car.bodyTypeName || ""
              }`,
          };
};

export const getEngineName = (engine: CompareMotorizationType): string => {
    if (!engine) return "";
    return `${engine.engineName || ""} ${engine.wheeldriveName || ""} ${engine.transmissionName || ""}`.trim();
};
